export default "__VITE_ASSET__43d564f9__"